import React, { useState, useEffect } from 'react';
import InvoiceList from './components/invoiceList';
import InvoiceModal from './components/invoiceModal';
import useInvoiceState from './hooks/useInvoiceState';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';

const InvoicePage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();
  const {
    invoices,
    customers,
    loading,
    setInvoices,
    fetchInvoices,
    addOrUpdate,
    downloadPDFFile,
    commitTransacitionData,
    voidTransacitionData,
    changeInvoiceStatus,
  } = useInvoiceState();

  const [invoiceData, setInvoiceData] = useState(invoices);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingInvoice, setEditingInvoice] = useState(null);

  useEffect(() => {
    setInvoiceData(invoices);
  }, [invoices])

  const handleAdd = () => {
    navigate('/generate-invoice');
  };

  const handleSave = async (invoice) => {
    const response = await addOrUpdate(invoice);
    if (response?.success) {
      setModalOpen(false);
    }
    return response;
  };

  const submitInvoice = async (invoice_id, commit = 0) => {
    try {
      if (commit === 1) {
        const res = await commitTransacitionData({ invoice_id });
        if (res?.success) {
          const updatedData = invoiceData.map(invoice => +invoice.id === +invoice_id ? {...invoice, status: commit} : invoice);
          setInvoiceData(updatedData);
          messageApi.success('Invoice Commit success', 5);
        } else {
          const errorMessage = res?.response?.data?.error?.message;
          if (errorMessage) {
            messageApi.error(errorMessage, 5);
          } else {
            messageApi.error(res.message, 5);
          }
        }
      } else if (commit === 2) {
        const res = await voidTransacitionData({ invoice_id });
        if (res?.success) {
          const updatedData = invoiceData.map(invoice => +invoice.id === +invoice_id ? {...invoice, status: commit} : invoice);
          setInvoiceData(updatedData);
          messageApi.success('Invoice Void success', 5);
        } else {
          const errorMessage = res?.response?.data?.error?.message;
          if (errorMessage) {
            messageApi.error(errorMessage, 5);
          } else {
            messageApi.error(res.message, 5);
          }
        }
      } else {
        const res = await downloadPDFFile({ invoice_id });
        // console.log({ pdfResponse: res });
        if (res?.success) {
          const blob = new Blob([res.data], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = res.fileName;
          a.click();
          messageApi.success('Invoice downloaded', 5);
        } else {
          const errorMessage = res?.response?.data?.error?.message;
          if (errorMessage) {
            messageApi.error(errorMessage, 5);
          } else {
            messageApi.error(res.message, 5);
          }
        }
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.error?.message;
      if (errorMessage) {
        messageApi.error(errorMessage, 5);
      } else {
        if (commit === 1) {
          messageApi.error('Invoice commit failed.', 5);
        } else if (commit === 2) {
          messageApi.error('Invoice void failed.', 5);
        } else {
          messageApi.error('Invoice download failed.', 5);
        }
      }
      console.error('PDF download/commit failed:', commit, error);
    }
  };

  const submitInvoiceStatus = async (invoice_id, invoice_status, invoice_pay_date) => {
    try {
      const res = await changeInvoiceStatus({ invoice_id, invoice_status, invoice_pay_date });
      if (res?.success) {
        const updatedData = invoiceData.map(invoice => +invoice.id === +invoice_id ? {...invoice, invoice_status, invoice_pay_date} : invoice);
        setInvoiceData(updatedData);
        messageApi.success('Invoice status update success', 5);
      } else {
        const errorMessage = res?.response?.data?.error?.message;
        if (errorMessage) {
          messageApi.error(errorMessage, 5);
        } else {
          messageApi.error(res.message, 5);
        }
      }
    } catch (err) {
      const errorMessage = err?.response?.data?.error?.message;
      if (errorMessage) {
        messageApi.error(errorMessage, 5);
      } else {
        messageApi.error(err.message, 5);
      }
    }
  }

  return (
    <>
      {contextHolder}
      <InvoiceList
        invoices={invoiceData}
        loading={loading}
        onAdd={handleAdd}
        submitInvoice={submitInvoice}
        submitInvoiceStatus={submitInvoiceStatus}
        customers={customers}
        fetchInvoices={fetchInvoices}
        setInvoices={setInvoices}
      />
      <InvoiceModal
        visible={modalOpen}
        onCancel={() => setModalOpen(false)}
        onSave={handleSave}
        initialData={editingInvoice}
      />
    </>
  );
};

export default InvoicePage;
